import { Tag }        from 'antd';
import { formatDate } from 'ClientService';
import React          from 'react';

export const PoolRequestShortKey = ({ value, record }) => !record.poolRequest ? '' : record.poolRequest.shortKey || '-'
